<!-- TEMPLATE -->
<template>
  <div :class="deanSearchFieldClass">
    <input
      type="search"
      :name="name"
      v-model="inputValue"
      @focus="focus = true"
      @blur="focus = false"
      :required="true"
    />
    <label>
      <slot></slot>
    </label>
    <dean-icon
      class="dean-search-field-icon"
      :glyph="search"
      :height="20"
      @click.native="updateSearch"
    ></dean-icon>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

// SVG
import search from '../svg/feather-icons/search.svg';

// COMPONENTS
import deanIcon from './deanIcon.vue';

@Component({
  components: {
    deanIcon
  }
})
export default class deanSearchField extends Vue {
  // PROPS
  @Prop({ default: 'search' }) id!: string;
  @Prop({ default: '' }) value!: string;
  @Prop() name!: string;
  @Prop() columns!: { [column: string]: any };
  @Prop({ default: false }) animate!: boolean;

  // DATA
  inputValue: string = this.value;
  search: object = search;
  focus: boolean = false;
  timer!: number;

  @Watch('focus')
  onFocus() {
    console.log('search focus = ' + this.focus);
  }

  @Watch('value')
  updateValue() {
    this.inputValue = this.value;
  }

  @Watch('inputValue')
  liveSearch() {
    let dql = '';

    if (
      this.inputValue != '' &&
      this.inputValue != null &&
      this.inputValue != undefined
    ) {
      for (let column in this.columns) {
        if (this.columns[column].sort) {
          let searchValue = this.inputValue.split(/[ ,./| ]+/);
          if (this.columns[column].dql) {
            for (let value in searchValue) {
              dql =
                dql +
                this.columns[column].dql.toLowerCase() +
                '=%' +
                encodeURIComponent(searchValue[value]) +
                '%|';
            }
          }
        }
      }
    }
    
    const startTimer = () => {
      this.timer = setTimeout(() => {
        this.$emit('live-search', this.inputValue);
        this.$emit('live-dql', dql)
      }, 1000, this.id);
      console.log(this.timer);
    }

    const stopTimer = () => {
      clearTimeout(this.timer);
      console.log(this.timer)
      console.log('stopTimer');
    }

    stopTimer();
    if (this.inputValue.length == 0 || this.inputValue.length > 2) {
      startTimer();
    }
  }


  // COMPUTED
  get deanSearchFieldClass() {
    let value = 'dean-search-field';
    if (this.animate) value += ` dean-search-field-animate`;
    return value;
  }

  // METHOD
  keyPressListener(event: any) {
    if (event.keyCode == 13 && this.focus == true) {
      this.updateSearch();
    }
  }

  updateSearch() {
    this.$emit('input', this.inputValue);

    let dql = '';

    console.log(this.inputValue);
    if (
      this.inputValue != '' &&
      this.inputValue != null &&
      this.inputValue != undefined
    ) {
      for (let column in this.columns) {
        if (this.columns[column].sort) {
          let searchValue = this.inputValue.split(/[ ,./| ]+/);
          for (let value in searchValue) {
            dql =
              dql +
              this.columns[column].dql.toLowerCase() +
              '=%' +
              encodeURIComponent(searchValue[value]) +
              '%|';
          }
        }
      }
    }

    this.$emit('dql', dql);
  }

  created() {
    window.addEventListener('keypress', this.keyPressListener);
  }

  destroyed() {
    window.removeEventListener('keypress', this.keyPressListener);
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// DEAN SEARCH FIELD
@import '../scss/vars';

.dean-search-field {
  display: inline-flex;
  position: relative;
  padding: 10px;
  width: 100%;

  .dean-search-field-icon {
    fill: var(--color-dark-shade-4, $color-dark-shade-4);
    position: absolute;
    top: 17.5px;
    @include calc(right, '5px + 15px');
    @include transition(all ease 0.8s);
    &:hover {
      fill: var(--color-link, $color-link);
      cursor: pointer;
    }
  }

  input {
    display: block;
    left: 0;
    color: var(--color-dark, $color-dark);
    padding: 10px;
    background: none;
    background: linear-gradient(
      to left,
      white 50%,
      var(--color-light-shade-2, $color-light-shade-2) 50%
    );
    background-size: 200% 100%;
    background-position: right bottom;
    border: 1px solid var(--color-light-shade-2, $color-light-shade-2);
    @include calc(width, '100% - 22px');
    @include transition(all ease 0.8s);
    @include border-radius(10px);
    &:focus {
      outline: none;
      background-position: left bottom;
      box-shadow: 0px 0px 10px 2px var(--color-primary, $color-primary);
      ~ .dean-search-field-icon {
        fill: var(--color-link, $color-link);
      }
    }
    &:focus ~ label,
    &:valid ~ label {
      display: none;
      color: var(--color-link, $color-link);
    }
  }

  label {
    position: absolute;
    left: 30px;
    top: 20px;
    height: 20px;
    font-weight: 500;
    color: var(--color-dark-shade-4, $color-dark-shade-4);
    pointer-events: none;
    overflow-x: hidden;
    @include transition(all ease 0.4s);
  }
}

.dean-search-field-animate {
  .dean-search-field-icon {
    @include calc(right, '5% + 5px + 15px');
  }
  input {
    @include calc(width, '95% - 22px');
    &:focus {
      @include calc(width, '100% - 22px');
      ~ .dean-search-field-icon {
        @include calc(right, '5px + 15px');
      }
    }
  }
}
</style>
